module.exports = __webpack_public_path__ + "img/Frame_5.5adf5895.png";